// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"490":"de30774c","862":"2661779c"}[chunkId] + ".chunk.css";
};